export default "__VITE_ASSET__CzaZU2IG__"